import { defineMessages } from 'react-intl';

export default defineMessages({
    addGuarantor: {
        id: 'Add guarantor',
        defaultMessage: 'Add guarantor'
    },
    removeGuarantor: {
        id: 'Remove guarantor',
        defaultMessage: 'Remove guarantor'
    },
    saveAndReturnToApplication: {
        id: 'Save and return to application',
        defaultMessage: 'Save and return to application'
    },
    editGuarantorDetails: {
        id: 'Edit guarantor details',
        defaultMessage: 'Edit guarantor details'
    }
});
